<template>
  <v-card>
    <v-divider></v-divider>
    <v-card-text>
      <form>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs12>
              <message :messages="messages"></message>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{labels.scheme}}</v-subheader>
              <div class="title">{{this.$store.state.parameters.scheme.schemeMenu.sideMenuTitle}}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{labels.planNo}}</v-subheader>
              <div class="title">{{this.$store.state.parameters.scheme.pkgPlanMenu.pkgPlanTitle}}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{labels.riskNo}}</v-subheader>
              <div class="title">{{this.$store.state.parameters.scheme.pkgRiskMenu.pkgRiskTitle}}</div>
            </v-flex>
            <v-flex xs6 v-if="newItem">
              <v-text-field :label="labels.itemNo" v-model="pkgRiskItemForm.itemNo" :error-messages="errors.collect('itemNo')" v-validate="'required|numeric|max:10'" data-vv-name="itemNo" :data-vv-as="labels.itemNo"></v-text-field>
            </v-flex>
            <v-flex xs6 v-else>
              <v-subheader class="queryLabel">{{labels.itemNo}}</v-subheader>
              <div class="title">{{pkgRiskItemForm.itemNo}}</div>
            </v-flex>
            <v-flex xs6>
              <v-autocomplete :items="benefitList" v-model="pkgRiskItemForm.benefit" :label="labels.benefit" item-text="label" item-value="value" data-vv-name="benefit" :data-vv-as="labels.benefit" :error-messages="errors.collect('benefit')" clearable></v-autocomplete>
            </v-flex>
            <v-flex xs6>
              <v-autocomplete :items="uomList" v-model="pkgRiskItemForm.uom" :label="labels.uom" item-text="label" item-value="value" data-vv-name="uom" :data-vv-as="labels.uom" :error-messages="errors.collect('uom')" v-validate="'required'"></v-autocomplete>
            </v-flex>
            <v-flex xs6>
              <v-text-field :label="labels.uomAmt" v-num-mask="{negative: true, intScale: 16, decScale: 2}" v-model="pkgRiskItemForm.uomAmt" :error-messages="errors.collect('uomAmt')" data-vv-name="uomAmt" :data-vv-as="labels.uomAmt"></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-autocomplete :items="uomUnList()" v-model="pkgRiskItemForm.uomUn" :label="labels.uomUn" item-text="label" item-value="value" data-vv-name="uomUn" :data-vv-as="labels.uomUn" :error-messages="errors.collect('uomUn')" clearable></v-autocomplete>
            </v-flex>
            <v-flex xs6>
              <v-text-field v-model="pkgRiskItemForm.minSi" v-num-mask="{negative: true, intScale: 16}" :label="labels.minSi" :error-messages="errors.collect('minSi')" data-vv-name="minSi" :data-vv-as="labels.minSi" v-validate="maxValidation(pkgRiskItemForm.maxSi)"></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field v-model="pkgRiskItemForm.maxSi" v-num-mask="{negative: true, intScale: 16}" :label="labels.maxSi" :error-messages="errors.collect('maxSi')" data-vv-name="maxSi" :data-vv-as="labels.maxSi" v-validate="minValidation(pkgRiskItemForm.minSi)"></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field v-model="pkgRiskItemForm.incSi" v-num-mask="{negative: true, intScale: 16, decScale: 2}" :label="labels.incSi" :error-messages="errors.collect('incSi')" data-vv-name="incSi" :data-vv-as="labels.incSi"></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-checkbox :label="labels.protSi" v-model="pkgRiskItemForm.protSi"></v-checkbox>
            </v-flex>
          </v-layout>
        </v-container>
      </form>
    </v-card-text>
    <v-flex xs12>
      <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSaveItemGeneral">
        {{ newItem ? 'Save Item' : 'Update Item' }}
        <v-icon right>{{newItem ? 'mdi-plus' : 'mdi-content-save'}}</v-icon>
      </v-btn>
    </v-flex>
  </v-card>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import { extractMenu } from '@/utils/extract'
import { formatDisplayNumber, removeFormatNumber } from '@/utils/number.js'
import { uomUN } from '@/const/underwriting/package'
export default {
  data() {
    return {
      labels: {
        scheme: 'Scheme*',
        planNo: 'Package Plan*',
        riskNo: 'Risk No*',
        itemNo: 'Item No*',
        benefit: 'Default Benefit',
        uom: 'Default Unit Of Measure*',
        uomUn: 'Unit Of Measure UN',
        uomAmt: 'Unit Of Measure Amount',
        minSi: 'Minimum Sum Insured',
        maxSi: 'Maximum Sum Insured',
        protSi: 'Protect Sum Insured',
        incSi: 'Increase Sum Insured',
        stdItemTxt: 'Standard Item Txt'
      },
      pkgRiskItemForm: {
        scheme: null,
        schemeDesc: null,
        planNo: null,
        planDesc: null,
        riskNo: null,
        itemNo: null,
        benefit: null,
        uom: null,
        uomAmt: 0.00,
        uomUn: null,
        minSi: 0.00,
        maxSi: 0.00,
        protSi: false,
        incSi: 0.00
      },
      benefitList: [],
      uomList: [],
      stdItemTxtList: [],
      submitting: false,
      newItem: false
    }
  },
  computed: {
    pkgRiskMenu() {
      return this.$store.state.parameters.scheme.pkgRiskMenu
    }
  },
  watch: {
    'ids.itemNo': function (value) {
      this.resetMessages()
      this.resetValidator()
      Promise.all([this.doBenefitInit(), this.doUomList()])
      this.pkgRiskItemForm.scheme = this.ids.scheme
      this.pkgRiskItemForm.itemNo = value
      this.pkgRiskItemForm.riskNo = this.ids.riskNo
      if (value !== 'new') {
        this.newItem = false
        if (value !== null) {
          this.fetchData(value)
        }
      } else {
        this.newItem = true
        this.doClearForm()
      }
    }
  },
  methods: {
    minValidation(value) {
      const min = removeFormatNumber(value)
      return 'mask_min_value:' + min
    },
    maxValidation(value) {
      const max = removeFormatNumber(value)
      return 'mask_max_value:' + max
    },
    async fetchData(itemNo) {
      if (!this.newItem) {
        const apiURI = this.pkgRiskMenu.menu.pkgRiskItemGet
        if (apiURI) {
          try {
            const expand = {
              scheme: this.ids.scheme,
              planNo: this.ids.planNo,
              riskNo: this.ids.riskNo,
              itemNo: this.ids.itemNo
            }
            const result = await this.$http.get(expandURI(apiURI, expand))
            const { data } = result.data
            if (data) {
              this.pkgRiskItemForm.scheme = data.pkgRiskItem.scheme
              this.pkgRiskItemForm.schemeDesc = data.pkgRiskItem.schemeDesc
              this.pkgRiskItemForm.planNo = data.pkgRiskItem.planNo
              this.pkgRiskItemForm.planDesc = data.pkgRiskItem.planDesc
              this.pkgRiskItemForm.riskNo = data.pkgRiskItem.riskNo
              this.pkgRiskItemForm.itemNo = data.pkgRiskItem.itemNo
              this.pkgRiskItemForm.benefit = data.pkgRiskItem.benefit
              this.pkgRiskItemForm.uom = data.pkgRiskItem.uom
              this.pkgRiskItemForm.uomAmt = formatDisplayNumber(data.pkgRiskItem.uomAmt)
              this.pkgRiskItemForm.uomUn = data.pkgRiskItem.uomUn
              this.pkgRiskItemForm.minSi = formatDisplayNumber(data.pkgRiskItem.minSi)
              this.pkgRiskItemForm.maxSi = formatDisplayNumber(data.pkgRiskItem.maxSi)
              this.pkgRiskItemForm.protSi = data.pkgRiskItem.protSi
              this.pkgRiskItemForm.incSi = formatDisplayNumber(data.pkgRiskItem.incSi)
              this.menu = extractMenu(result.data._links)
            } else {
              this.errorMessage('fail to get data from server, please try again')
            }
          } catch (error) {
            const { data } = error.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          }
        } else {
          this.errorMessage('Invalid API URL - Risk Item Review')
        }
      }
    },
    async doSaveItemGeneral() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newItem) {
            this.doCreateGeneral()
          } else {
            this.doUpdateGeneral()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreateGeneral() {
      const apiURI = this.pkgRiskMenu.menu.pkgRiskItemCreate
      if (apiURI) {
        try {
          const formatForm = {
            scheme: this.pkgRiskItemForm.scheme,
            planNo: this.pkgRiskItemForm.planNo,
            riskNo: parseInt(this.pkgRiskItemForm.riskNo),
            itemNo: parseInt(this.pkgRiskItemForm.itemNo),
            benefit: this.pkgRiskItemForm.benefit,
            uom: this.pkgRiskItemForm.uom,
            uomAmt: removeFormatNumber(this.pkgRiskItemForm.uomAmt),
            uomUn: this.pkgRiskItemForm.uomUn,
            minSi: removeFormatNumber(this.pkgRiskItemForm.minSi),
            maxSi: removeFormatNumber(this.pkgRiskItemForm.maxSi),
            protSi: this.pkgRiskItemForm.protSi,
            incSi: removeFormatNumber(this.pkgRiskItemForm.incSi)
          }
          const result = await this.$http.post(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$emit('resetTab', 3)
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdateGeneral() {
      const apiURI = this.menu.pkgRiskItemUpdate
      if (apiURI) {
        try {
          const formatForm = {
            scheme: this.pkgRiskItemForm.scheme,
            planNo: this.pkgRiskItemForm.planNo,
            riskNo: parseInt(this.pkgRiskItemForm.riskNo),
            itemNo: parseInt(this.pkgRiskItemForm.itemNo),
            benefit: this.pkgRiskItemForm.benefit,
            uom: this.pkgRiskItemForm.uom,
            uomAmt: removeFormatNumber(this.pkgRiskItemForm.uomAmt),
            uomUn: this.pkgRiskItemForm.uomUn,
            minSi: removeFormatNumber(this.pkgRiskItemForm.minSi),
            maxSi: removeFormatNumber(this.pkgRiskItemForm.maxSi),
            protSi: this.pkgRiskItemForm.protSi,
            incSi: removeFormatNumber(this.pkgRiskItemForm.incSi)
          }
          const result = await this.$http.put(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.fetchData(this.ids.itemNo)
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API URL for Updated Risk Item')
      }
    },
    doClearForm() {
      this.resetValidator()
      this.resetMessages()
      this.pkgRiskItemForm.scheme = this.ids.scheme
      this.pkgRiskItemForm.schemeDesc = null
      this.pkgRiskItemForm.planNo = this.ids.planNo
      this.pkgRiskItemForm.planDesc = null
      this.pkgRiskItemForm.riskNo = this.ids.riskNo
      this.pkgRiskItemForm.itemNo = null
      this.pkgRiskItemForm.benefit = null
      this.pkgRiskItemForm.uom = null
      this.pkgRiskItemForm.uomAmt = 0.00
      this.pkgRiskItemForm.uomUn = null
      this.pkgRiskItemForm.minSi = 0.00
      this.pkgRiskItemForm.maxSi = 0.00
      this.pkgRiskItemForm.protSi = false
      this.pkgRiskItemForm.incSi = 0.00
    },
    async doBenefitInit() {
      const apiURI = this.pkgRiskMenu.menu.benefitList
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            if (this.benefitList.length > 0) {
              this.benefitList = []
            }
            this.benefitList = data.benefitList
          } else {
            this.benefitList = []
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.benefitList = []
      }
    },
    async doUomList() {
      const apiURI = this.pkgRiskMenu.menu.uomList
      if (apiURI) {
        try {
          this.uomList = []
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            this.uomList = data.uomList
          } else {
            this.uomList = []
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.uomList = []
      }
    },
    uomUnList() {
      const list = Object.freeze(uomUN)
      let convertArray = Object.keys(list).map(key => {
        return {
          label: key + ' - ' + (list[key] === null ? 'Blank' : list[key]),
          value: key
        }
      })
      return convertArray
    }
  },
  mixins: [
    MessageMixin
  ],
  props: {
    ids: {
      type: Object,
      default() {
        return {
          scheme: null,
          planNo: null,
          riskNo: null,
          itemNo: null
        }
      }
    }
  }
}
</script>

<style>
</style>
